<template>
  <div class="user-manual-wrap">
    <div class="function-button d-inline-block" @click="goto('userBarcode')">
      <div class="icon-wrap">
        <img src="/static/svg/barcode.svg" alt="">
      </div>
      <div class="text-center">
        更改條碼
      </div>
    </div>

    <div class="function-button d-inline-block" @click="goto('userPassword')">
      <div class="icon-wrap">
        <img src="/static/svg/key.svg" alt="">
      </div>
      <div class="text-center">
        更改密碼
      </div>
    </div>

    <div class="function-button d-inline-block" @click="goto('userFingerprint')" v-if="$store.state.generalSetting.can_login_with_fingerprinter">
      <div class="icon-wrap">
        <img src="/static/svg/fingerprint.svg" alt="">
      </div>
      <div class="text-center">
        更改指紋
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Password',
  methods: {
    goto(val) {
      this.$router.push({ name: val });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?0c2df662